// Generated by BUCKLESCRIPT VERSION 2.2.0, PLEASE EDIT WITH CARE
'use strict';

var Decoders = require("./decoders");


const configFilename = process.env.NODE_ENV || "development"
  
;

var config = Decoders.config((require("../config/" + configFilename).default));

exports.config = config;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/configuration.re
// module id = 63
// module chunks = 0